import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=918402aa&scoped=true&"
import script from "./TablePagination.vue?vue&type=script&lang=ts&"
export * from "./TablePagination.vue?vue&type=script&lang=ts&"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=918402aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918402aa",
  null
  
)

export default component.exports